/**
 * LDM · UGC — reproducción por visibilidad
 * ---------------------------------------------------------------------------
 * Los videos llegan con `preload="none"` y sin `autoplay`: así, quien no baja
 * hasta esta sección no descarga un solo byte de video. Este archivo los pone
 * en marcha cuando la tarjeta asoma y los detiene cuando se va, de modo que en
 * un carrusel de seis tarjetas solo consuma datos la que se está mirando.
 *
 * Van sin sonido y sin controles, en bucle. No hay nada que pulsar: si algo
 * llegara a pausarlos —el navegador al cambiar de pestaña, un gesto del
 * sistema— se reanudan solos mientras sigan a la vista.
 *
 * Si este archivo no llega a ejecutarse, la tarjeta muestra el póster del
 * video en vez de quedarse en blanco.
 */
(function () {
  'use strict';

  var SIN_MOVIMIENTO =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function arrancar(video) {
    // `play()` devuelve una promesa que se rechaza si el navegador aún no
    // permite la reproducción; sin el catch queda un error suelto en consola.
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function init() {
    var videos = document.querySelectorAll('.ldm-ugc__video');
    if (!videos.length) return;

    Array.prototype.forEach.call(videos, function (video) {
      if (video.dataset.ldmInit === 'true') return;
      video.dataset.ldmInit = 'true';

      // Requisitos del autoplay sin interacción: sin sonido y en línea, no a
      // pantalla completa. El atributo `muted` no basta en Safari.
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.controls = false;
      video.setAttribute('disablepictureinpicture', '');

      // Safari reproduce HLS de forma nativa y descarga el video por trozos,
      // así que gasta solo lo que se ve. Se comprueba el soporte en vez de
      // ofrecerlo como fuente alternativa: un navegador que acepta la lista y
      // luego falla al decodificarla no siempre pasa al MP4, y el video se
      // quedaba en negro.
      var hls = video.dataset.ldmHls;
      if (hls && video.canPlayType('application/vnd.apple.mpegurl') !== '') {
        video.src = hls;
      }

      // Nadie debería poder pararlo: si algo lo pausa mientras está a la vista,
      // vuelve a arrancar.
      video.addEventListener('pause', function () {
        if (video.dataset.ldmVisible === 'true') arrancar(video);
      });
    });

    if (SIN_MOVIMIENTO) {
      // Quien pidió menos movimiento ve el póster quieto, no un bucle.
      return;
    }

    var observador = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (entrada) {
          var video = entrada.target;
          if (entrada.isIntersecting) {
            video.dataset.ldmVisible = 'true';
            // La descarga empieza aquí, no al cargar la página.
            if (video.preload === 'none') {
              video.preload = 'auto';
              video.load();
            }
            arrancar(video);
          } else {
            video.dataset.ldmVisible = 'false';
            video.pause();
          }
        });
      },
      // Con la mitad de la tarjeta dentro basta: en un carrusel horizontal
      // exigir más haría que el video de al lado no arrancara nunca.
      { threshold: 0.5 }
    );

    Array.prototype.forEach.call(videos, function (video) {
      observador.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
